export default __webpack_public_path__ + "static/media/env-check.f076684b.svg";